'use strict';

const i18n = require('i18next');
const Mn = require('backbone.marionette');
const ContentListView = require('data/ui/view/content/list');
const FolderItemView = require('data/ui/view/content/folder-item');
const ContainerRepository = require('data/domain/repository/container/index');
const ContentRepository = require('data/domain/repository/content/index');
const ContentEditView = require('data/ui/view/modal/content-edit');
const ContentService = require('data/app/service/content/index');
const NavWidthChanger = require('balus/ui/view/nav-width-changer');
const ModalView = require('common/ui/view/modal/index');
const DataPermission = require('data/domain/entity/permission');
const Template = require('balus/ui/template/body/data-content/nav/index.hbs');

module.exports = Mn.View.extend({
    template: Template,
    regions: {
        contentList: '.content-list-wrapper',
        attachmentsList: '.attachments-list-wrapper',
        widthChanger: '#nav-width-changer-wrapper'
    },
    ui: {
        contentAddButton: '.content-add-button',
    },
    events: {
        'click @ui.contentAddButton': 'addContent',
    },
    modelEvents: {
        'change': 'render'
    },
    templateContext: function() {
        const context = this.getOption('context');
        return {
            isCreatable: context.getProjectRole().getPermission(
                DataPermission.DataContentCreatePermission
            ).isPermitted(context)
        };
    },

    onRender: function() {
        this.showChildView('widthChanger', new NavWidthChanger());

        const context = this.getOption('context');
        const content = this.getOption('content');
        const project = this.model;

        ContainerRepository.find(project)
            .fetchRootOnce()
            .then(rootContainer => {
                // rootContainer 配下の Container(フォルダ) 一覧を取得する
                ContainerRepository.find(project)
                    .fetchChildContainersOnce(rootContainer)
                    .then(containers => {
                        // その中に attachments という名前のシステムフォルダがあれば、それ用の枠に表示する
                        const attachmentsContainer = containers.find(c => {
                            return c.isSystem() && c.getSystemName() === 'attachments';
                        });
                        if (attachmentsContainer) {
                            this.showChildView('attachmentsList', new FolderItemView({
                                content: content,
                                context: context,
                                model: attachmentsContainer,
                            }));
                        }
                    });

                // rootContainer 配下の Data 一覧を取得する
                return ContentRepository.find(this.model)
                    .fetchContentsOnce(rootContainer.id, 10);
            })
            .then(contents => {
                this.showChildView('contentList',
                    new ContentListView({
                        content: content,
                        context: context,
                        collection: contents
                    })
                );
            });
    },

    addContent: function() {
        const contentEditModal = new ModalView({
            model: this.model,
            title: i18n.t('data:edit.title'),
            bodyView: new ContentEditView({
                project: this.model
            }),
            onChildviewSave: function() {
                const contentJSON = this.getChildView('body').getContent();
                this.disableButtons();
                (new ContentService.ContentAddService({
                    project: this.model,
                    name: contentJSON.name,
                    uri: contentJSON.uri,
                    storageObjectId: contentJSON.storageObjectId,
                    thumbnailURI: contentJSON.thumbnailURI,
                    uploaded: contentJSON.uploaded,
                    parentContainer: 'root'
                }))
                    .add()
                    .then(() => {
                        this.hide();
                        this.trigger('add:content');
                    });
            }
        });
        contentEditModal.show();
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/data-content/nav/index.js